/**
 * Nomad — tag/price filter UI (dropdowns, sidebar checkboxes, active facets sync).
 */
(function () {
  const CF = () => window.NomadCollectionFilters;

  const TAG_LABELS = {
    'gift-for-kids': 'Kids',
    'gift-for-women': 'Women',
    'gift-for-men': 'Men',
    'gift-for-pastors': 'Pastors',
    'gift-baptism': 'Baptism',
    'gift-wedding': 'Wedding',
    'gift-mothers-day': 'Mothers Day',
    'gift-easter': 'Easter',
    'gift-christmas': 'Christmas',
    'gift-english': 'English',
    'gift-spanish': 'Espanol',
    'bible-material-leather': 'Leather',
    'bible-material-hardcover': 'Hardcover',
    'bible-material-paperback': 'Paperback',
    'bible-lang-english': 'English',
    'bible-lang-spanish': 'Espanol',
  };

  function navigate(url) {
    if (url && url !== window.location.pathname + window.location.search) {
      window.location.assign(url);
    }
  }

  function getActiveTags() {
    if (!CF()) return [];
    return CF().getSelectedTags(window.location.pathname, window.location.search);
  }

  function updateProductCount(visible) {
    const text = visible === 1 ? '1 product' : `${visible} products`;
    ['ProductCountDesktop', 'ProductCount'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.textContent = text;
    });
  }

  function applyNomadClientFilter() {
    if (!CF()) return;

    const selectedTags = getActiveTags();
    const { gte, lte } = CF().getPriceFromSearch(window.location.search);
    const hasPriceFilter = Boolean(gte || lte);
    const useClientTags = CF().getTagsFromSearch(window.location.search).length > 0;

    if (!useClientTags) {
      document.querySelectorAll('#product-grid .grid__item.nomad-filter-hidden').forEach((item) => {
        item.classList.remove('nomad-filter-hidden');
        item.hidden = false;
      });
      const emptyEl = document.getElementById('nomad-filter-empty');
      if (emptyEl) emptyEl.hidden = true;
      const grid = document.getElementById('product-grid');
      if (grid) grid.hidden = false;
      return;
    }

    const handle = CF().getCollectionHandleFromPath(window.location.pathname);
    if (!handle) return;

    fetch(`/collections/${handle}/products.json?limit=250`)
      .then((res) => (res.ok ? res.json() : { products: [] }))
      .then((data) => {
        const matchingHandles = new Set(
          (data.products || [])
            .filter((p) => {
              const tags = (p.tags || '').split(',').map((t) => t.trim()).filter(Boolean);
              if (!CF().productMatchesTags(tags, selectedTags)) return false;
              if (hasPriceFilter) {
                const cents = Math.min(...(p.variants || []).map((v) => v.price || 0));
                if (!CF().productMatchesPrice(cents, gte, lte)) return false;
              }
              return true;
            })
            .map((p) => p.handle),
        );

        const items = document.querySelectorAll('#product-grid .grid__item[data-product-handle]');
        let visibleOnPage = 0;

        items.forEach((item) => {
          const show = matchingHandles.has(item.dataset.productHandle || '');
          item.classList.toggle('nomad-filter-hidden', !show);
          item.hidden = !show;
          if (show) visibleOnPage += 1;
        });

        const totalMatch = matchingHandles.size;
        updateProductCount(totalMatch);

        const grid = document.getElementById('product-grid');
        let emptyEl = document.getElementById('nomad-filter-empty');
        if (totalMatch === 0 && grid) {
          if (!emptyEl) {
            emptyEl = document.createElement('div');
            emptyEl.id = 'nomad-filter-empty';
            emptyEl.className = 'nomad-filter-empty title-wrapper center';
            emptyEl.innerHTML =
              '<h2 class="title title--primary">No products match your filters.<br><a href="' +
              CF().getCollectionBaseFromPath(window.location.pathname) +
              '" class="underlined-link link">Clear filters</a></h2>';
            grid.parentElement?.appendChild(emptyEl);
          }
          emptyEl.hidden = false;
          grid.hidden = true;
        } else if (grid) {
          grid.hidden = false;
          if (emptyEl) emptyEl.hidden = true;
        }
      })
      .catch(() => {
        /* fallback: filter visible page items only */
        const items = document.querySelectorAll('#product-grid .grid__item[data-product-tags]');
        let visible = 0;
        items.forEach((item) => {
          const productTags = (item.dataset.productTags || '')
            .split(',')
            .map((t) => t.trim())
            .filter(Boolean);
          let show = CF().productMatchesTags(productTags, selectedTags);
          if (show && hasPriceFilter) {
            show = CF().productMatchesPrice(item.dataset.productPriceCents, gte, lte);
          }
          item.classList.toggle('nomad-filter-hidden', !show);
          item.hidden = !show;
          if (show) visible += 1;
        });
        updateProductCount(visible);
      });
  }

  function initNomadTagFilterDropdowns() {
    if (!CF()) return;
    const { buildTagFilterUrl, TAG_FILTER_GROUPS } = CF();

    document.querySelectorAll('[data-nomad-tag-filter-group]').forEach((select) => {
      if (select.dataset.nomadTagDropdownInit === 'true') return;
      select.dataset.nomadTagDropdownInit = 'true';

      const groupKey = select.dataset.nomadTagFilterGroup;
      const collectionBase =
        select.dataset.collectionUrl || CF().getCollectionBaseFromPath(window.location.pathname);
      const activeTags = getActiveTags();
      const groupTags = TAG_FILTER_GROUPS[groupKey] || [];
      const activeInGroup = activeTags.find((t) => groupTags.includes(t)) || '';

      [...select.options].forEach((opt) => {
        const tag = opt.dataset.tag || '';
        opt.value = buildTagFilterUrl(
          collectionBase,
          groupKey,
          tag,
          window.location.pathname,
          window.location.search,
        );
      });

      if (activeInGroup) {
        const match = [...select.options].find((opt) => opt.dataset.tag === activeInGroup);
        if (match) select.value = match.value;
      } else {
        select.selectedIndex = 0;
      }

      select.addEventListener('change', () => navigate(select.value));
    });
  }

  function initNomadPriceDropdowns() {
    if (!CF()) return;
    const { buildPriceFilterUrl } = CF();

    document.querySelectorAll('[data-nomad-price-filter]').forEach((select) => {
      if (select.dataset.nomadPriceInit === 'true') return;
      select.dataset.nomadPriceInit = 'true';

      const collectionBase =
        select.dataset.collectionUrl || CF().getCollectionBaseFromPath(window.location.pathname);

      [...select.options].forEach((opt) => {
        const gte = opt.dataset.gte || '';
        const lte = opt.dataset.lte || '';
        opt.value = buildPriceFilterUrl(
          collectionBase,
          gte,
          lte,
          window.location.pathname,
          window.location.search,
        );
      });

      const { gte, lte } = CF().getPriceFromSearch(window.location.search);
      const match = [...select.options].find((opt) => opt.dataset.gte === gte && opt.dataset.lte === lte);
      if (match) select.value = match.value;

      select.addEventListener('change', () => navigate(select.value));
    });
  }

  function initNomadSidebarTagLinks() {
    if (!CF()) return;
    const { toggleTagUrl, removeTagUrl, getSelectedTags } = CF();

    document.querySelectorAll('[data-nomad-sidebar-tag-link]').forEach((link) => {
      if (link.dataset.nomadSidebarInit === 'true') return;
      link.dataset.nomadSidebarInit = 'true';

      const tag = link.dataset.nomadTag;
      const collectionBase =
        link.dataset.collectionUrl || CF().getCollectionBaseFromPath(window.location.pathname);
      const activeTags = getSelectedTags(window.location.pathname, window.location.search);
      const isActive = activeTags.includes(tag) || link.classList.contains('active');

      link.href = isActive
        ? removeTagUrl(collectionBase, tag, window.location.pathname, window.location.search)
        : toggleTagUrl(collectionBase, tag, window.location.pathname, window.location.search);

      link.setAttribute('aria-checked', isActive ? 'true' : 'false');
      link.classList.toggle('active', isActive);

      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(link.href);
      });
    });
  }

  function initNomadTagFilterChips() {
    if (!CF()) return;
    const { buildTagFilterUrl, removeTagUrl, findGroupForTag, getSelectedTags } = CF();

    document.querySelectorAll('a[data-nomad-tag]').forEach((link) => {
      if (link.dataset.nomadChipInit === 'true') return;
      link.dataset.nomadChipInit = 'true';

      const tag = link.dataset.nomadTag;
      const collectionBase =
        link.dataset.collectionUrl || CF().getCollectionBaseFromPath(window.location.pathname);
      const groupKey = link.dataset.nomadTagFilterGroup || findGroupForTag(tag);
      const activeTags = getSelectedTags(window.location.pathname, window.location.search);
      const isActive = activeTags.includes(tag) || link.classList.contains('is-active');

      if (isActive) {
        link.href = removeTagUrl(collectionBase, tag, window.location.pathname, window.location.search);
      } else if (groupKey) {
        link.href = buildTagFilterUrl(
          collectionBase,
          groupKey,
          tag,
          window.location.pathname,
          window.location.search,
        );
      } else {
        link.href = `${collectionBase}?nomad_tags=${encodeURIComponent(tag)}`;
      }

      link.addEventListener('click', (e) => {
        e.preventDefault();
        navigate(link.href);
      });
    });
  }

  function initNomadPriceFilterLinks() {
    if (!CF()) return;
    const { buildPriceFilterUrl } = CF();

    document.querySelectorAll('[data-nomad-price-link]').forEach((link) => {
      if (link.dataset.nomadPriceLinkInit === 'true') return;
      link.dataset.nomadPriceLinkInit = 'true';

      const collectionBase =
        link.dataset.collectionUrl || CF().getCollectionBaseFromPath(window.location.pathname);
      const gte = link.dataset.priceGte || '';
      const lte = link.dataset.priceLte || '';
      link.href = buildPriceFilterUrl(
        collectionBase,
        gte,
        lte,
        window.location.pathname,
        window.location.search,
      );

      link.addEventListener('click', (e) => {
        e.preventDefault();
        navigate(link.href);
      });
    });
  }

  function syncActiveFacetsFromUrl() {
    if (!CF()) return;
    const root = document.querySelector('[data-nomad-active-facets]');
    if (!root) return;

    const tags = getActiveTags();
    const { gte, lte } = CF().getPriceFromSearch(window.location.search);
    const hasPrice = Boolean(gte || lte);
    const clearUrl = root.dataset.clearUrl || CF().getCollectionBaseFromPath(window.location.pathname);
    const hasNative = root.querySelector('.nomad-active-facets__pills .nomad-active-facets__pill');

    if (!tags.length && !hasPrice && hasNative) {
      root.hidden = false;
      return;
    }
    if (!tags.length && !hasPrice) return;

    let bar = root.querySelector('.nomad-active-facets');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'nomad-active-facets small-hide';
      bar.setAttribute('aria-live', 'polite');
      bar.innerHTML =
        '<span class="nomad-active-facets__label">Filter:</span><div class="nomad-active-facets__pills" role="list"></div>';
      root.appendChild(bar);
    }

    const pills = bar.querySelector('.nomad-active-facets__pills');
    if (!pills || pills.dataset.urlSynced === 'true') {
      root.hidden = false;
      return;
    }

    pills.innerHTML = '';
    tags.forEach((tag) => {
      const label = TAG_LABELS[tag] || tag.replace(/^(gift|bible)-/, '').replace(/-/g, ' ');
      const collectionBase = CF().getCollectionBaseFromPath(window.location.pathname);
      const removeUrl = CF().removeTagUrl(
        collectionBase,
        tag,
        window.location.pathname,
        window.location.search,
      );
      const a = document.createElement('a');
      a.href = removeUrl;
      a.className = 'nomad-active-facets__pill';
      a.innerHTML = `<span>${label}</span><span class="nomad-active-facets__pill-x" aria-hidden="true">×</span>`;
      const li = document.createElement('facet-remove');
      li.setAttribute('role', 'listitem');
      li.appendChild(a);
      pills.appendChild(li);
    });

    if (hasPrice) {
      const collectionBase = CF().getCollectionBaseFromPath(window.location.pathname);
      const priceClearUrl = CF().buildCollectionFilterUrl(collectionBase, tags, {}, true);
      const a = document.createElement('a');
      a.href = priceClearUrl;
      a.className = 'nomad-active-facets__pill';
      a.innerHTML = '<span>Price</span><span class="nomad-active-facets__pill-x" aria-hidden="true">×</span>';
      const li = document.createElement('facet-remove');
      li.setAttribute('role', 'listitem');
      li.appendChild(a);
      pills.appendChild(li);
    }

    const clear = document.createElement('a');
    clear.href = clearUrl;
    clear.className = 'nomad-active-facets__pill nomad-active-facets__pill--clear';
    clear.textContent = 'Clear all';
    const clearLi = document.createElement('facet-remove');
    clearLi.setAttribute('role', 'listitem');
    clearLi.appendChild(clear);
    pills.appendChild(clearLi);
    pills.dataset.urlSynced = 'true';
    root.hidden = false;
  }

  function initNomadMobileFacets() {
    const wrapper = document.querySelector('.mobile-facets__wrapper:not(.nomad-gifts-hide-mobile-facets)');
    if (!wrapper || wrapper.dataset.nomadFacetsInit === 'true') return;
    wrapper.dataset.nomadFacetsInit = 'true';

    const main = wrapper.querySelector('.mobile-facets__main');
    const rootFooter = main?.querySelector(':scope > .mobile-facets__footer');
    const detailsList = wrapper.querySelectorAll('.mobile-facets__details.js-filter');

    function syncSubmenuState() {
      const anyOpen = [...detailsList].some((d) => d.open);
      main?.classList.toggle('nomad-facets--submenu-open', anyOpen);
      rootFooter?.classList.toggle('nomad-facets__footer--hidden', anyOpen);
    }

    detailsList.forEach((details) => {
      details.addEventListener('toggle', syncSubmenuState);
      const backBtn = details.querySelector('.mobile-facets__close-button');
      if (backBtn) {
        backBtn.addEventListener('click', (e) => {
          e.preventDefault();
          details.open = false;
        });
      }
    });

    wrapper.addEventListener('toggle', (e) => {
      if (e.target.matches('.mobile-facets__disclosure')) {
        if (!e.target.open) {
          detailsList.forEach((d) => {
            d.open = false;
          });
          syncSubmenuState();
        }
      }
    });

    syncSubmenuState();
  }

  function initNomadCollectionFilters() {
    if (!CF()) return;
    if (CF().migrateLegacyPathTags()) return;

    initNomadMobileFacets();
    initNomadTagFilterDropdowns();
    initNomadPriceDropdowns();
    initNomadSidebarTagLinks();
    initNomadTagFilterChips();
    initNomadPriceFilterLinks();
    syncActiveFacetsFromUrl();
    applyNomadClientFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNomadCollectionFilters);
  } else {
    initNomadCollectionFilters();
  }

  document.addEventListener('shopify:section:load', initNomadCollectionFilters);
})();
